import React, { Component } from "react";
import PropTypes from "prop-types";
import { Table } from "antd";
import { getEntityApplications } from "../../services/api-prosecution";

class Applications extends Component {
  static propTypes = {
    name: PropTypes.string.isRequired,
    field: PropTypes.string.isRequired
  };

  state = {
    applications: [],
    applicationsLoading: true
  };

  componentDidMount() {
    this._isMounted = true;
    this._getApplications(this.props.name, this.props.field);
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.name !== this.props.name) {
      this._getApplications(nextProps.name, nextProps.field);
    }
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  render() {
    const { applications, applicationsLoading } = this.state;
    const tableHeaders = [
      {
        dataIndex: "application_number",
        key: "application_number",
        title: "Application Number",
        width: 150
      },
      {
        dataIndex: "filing_date",
        key: "filing_date",
        title: "Filing Date",
        width: 120
      },
      {
        dataIndex: "invention_title",
        key: "invention_title",
        title: "Title"
      },
      {
        dataIndex: "disposal_type",
        key: "disposal_type",
        title: "Status",
        width: 80
      }
    ];
    return <Table columns={tableHeaders} dataSource={applications} loading={applicationsLoading} pagination={false} rowKey="application_number" size="middle" scroll={{ x: 750 }} />;
  }

  _getApplications = (name, field) => {
    getEntityApplications(name, field)
      .then(data => {
        if (this._isMounted)
          this.setState({
            applications: data.hits.hits.map(i => i._source),
            applicationsLoading: false
          });
      })
      .catch(() => {
        if (this._isMounted)
          this.setState({
            applications: [],
            applicationsLoading: false
          });
      });
  };
}

export default Applications;
